<template>
<div>


<b-table  responsive small   hover      :items="posts.postList" :fields="posts.tablePostFields">

<template #head(options)="data">
<span class="text-info">{{data.label}} </span>
</template>

<!-- блок инфо о посте -->
<template #cell(post_id)="data">
<div  v-if="data.item.post_id.slice(0,4) != 'wall'" style="margin-top:3px;max-width:300px">
<div>
<span style="color:green; ">
<strong>Используется как шаблон.</strong>
</span>
</div>
<v-tooltip top>
<v-btn slot="activator" disabled   class="ma-0" color="#273C51" hide-details flat   small   style="text-transform:none;">
<v-icon left>mdi-play</v-icon>
Запустить связку
</v-btn>
<span>Недоступная функция по данному тарифу</span>
</v-tooltip>
</div>
<div v-else style="max-width:300px">
<p>
<v-tooltip z-index="1"  v-if="!data.item.vk.deleted_reason"  right max-width="550"  min-width="550" offset-overflow>
<a slot="activator" target="_blank" :href="'https://vk.com/'+data.item.post_id">
<span  style="font-size:1.2em"> {{data.item.pre_text}}</span>
</a>
<showPost :item="data.item"></showPost>
</v-tooltip>

<a v-else target="_blank" :href="'https://vk.com/'+data.item.post_id">
<span style="font-size:1.2em;color:red"> {{data.item.vk.deleted_reason}}</span>
</a>

<br>

<span v-if="!data.item.vk.deleted_reason">
<span style="color:gray">{{data.item.vk.date | dateFormat}}</span>
<br>
<span>
<span style="margin-right:15px"><v-icon  small>mdi-heart-circle</v-icon><span style="margin-left:5px;color:gray">{{data.item.vk.likes.count}}</span></span>
<span style="margin-right:15px"><v-icon small>mdi-share</v-icon><span style="margin-left:5px;color:gray">{{data.item.vk.reposts.count}}</span></span></span>
<span v-if="data.item.vk.views"><v-icon small>mdi-eye</v-icon><span style="margin-left:5px;color:gray">{{data.item.vk.views.count}}</span></span>
</span>



<span v-else  style="color:red">{{data.item.status_text}}</span>



</p>
</div>
</template>
<!-- блок инфо о посте закрытие -->








<template #cell(task)="data">

<div v-if="data.item.task_id !=''">

<div v-if="data.item.status != 2">
<div style="cursor:pointer;color:gray;font-size:1.2em" @click="taskResources(data.item)">{{postTasks[data.item.task_id].name}}</div>
<p>
 <span style="color:gray">ID{{data.item.task_id}}</span> <br>
 <span @click="chTask(data.item.post_id,'')" style="color:#273C51;cursor:pointer">Открепить задание</span>
</p>

</div>

<!-- блок управление заданием -->
<div v-if="data.item.status == 2">
<div style="cursor:pointer;color:#4A76A8;font-size:1.2em" @click="taskResources(data.item)">{{postTasks[data.item.task_id].name}}</div>
<div style="margin-left:-15px">


<v-btn icon @click="activate(data.item,'run'); postTasks[data.item.task_id].status ='run'" v-if="postTasks[data.item.task_id].status.status ==  'stop'" >
<v-tooltip top max-width="250">  <v-icon color="#273C51" slot="activator">mdi-replay</v-icon> <span>{{postTasks[data.item.task_id].status.description.text}}</span>  </v-tooltip>
</v-btn>

<v-btn icon @click="activate(data.item,'stop'); postTasks[data.item.task_id].status ='stop'" v-if="postTasks[data.item.task_id].status.status ==  'run'" >
<v-tooltip top max-width="250">  <v-icon color="green" slot="activator">mdi-stop-circle-outline</v-icon> <span>{{postTasks[data.item.task_id].status.description.text}}</span>  </v-tooltip>
</v-btn>

<v-btn icon @click="activate(data.item,'run'); postTasks[data.item.task_id].status ='stop'" v-if="postTasks[data.item.task_id].status.status ==  'error'" >
<v-tooltip top max-width="250">  <v-icon color="red" slot="activator">mdi-alert-circle</v-icon> <span>{{postTasks[data.item.task_id].status.description.text}}</span>  </v-tooltip>
</v-btn>



<v-btn icon @click="taskMsg(data.item)">
<v-tooltip top max-width="250">  <v-icon color="green" slot="activator"   >mdi-message</v-icon> <span>Данное задание отправляет сообщения, кликните что бы посмотреть.</span>  </v-tooltip>
</v-btn>

<v-btn  icon @click="changeParams(data.item)">
<v-tooltip top max-width="250">  <v-icon color="#273C51" slot="activator"   >mdi-tune</v-icon> <span>Изменить параметры задания</span>  </v-tooltip>
</v-btn>
</div>
</div>
<!--блок управление заданием Закрытие-->

</div>


<div v-if="data.item.task_id ==''">
<p style="min-width:160px;max-width:160px">
<v-select @change="chTask(data.item.post_id,data.item.task_id)"
v-model="data.item.task_id" :items="tasks.tasksList" item-value = "task_id" item-text="name"
label="Прикрепить задание"
hide-details class="ma-0 pa-0"
>

</v-select>
</p>
</div>

</template>







<template #cell(status)="data"  >
<div  v-if="data.item.post_id.slice(0,4) != 'wall'" style="margin-top:3px"><span style="color:grey;margin-top:-13px">Шаблон</span></div>
<div v-else>
<v-tooltip top max-width="250">
<div>
<p style="font-size:1.2em">Последние изменение статуса:</p>
<span>{{data.item.status_text}}</span>
</div>
<p slot="activator" style="min-width:160px;max-width:160px">
<v-select class="ma-0 pa-0" dense hide-selected  hide-details @change="chStatus(data.item.post_id,data.item.status)" v-model="data.item.status" :items="statusList" item-value = "value" item-text="text"  >
<div slot="selection" slot-scope="selected">
<span style="color:gray" v-if="selected.item.value == '1'">{{selected.item.text}}</span>
<span style="color:green" v-if="selected.item.value == '2'">{{selected.item.text}}</span>
<span style="color:red" v-if="selected.item.value == '3'">{{selected.item.text}}</span>
<span style="color:red" v-if="selected.item.value == '4'">{{selected.item.text}}</span>
</div>
</v-select>
</p>
</v-tooltip>
<div   style="margin-top:-10px">
<div v-if="data.item.params.selectedAct == 'repost'" >
  <span v-if="!data.item.params.acts.repost.isBlock" style="color:#273C51">Репост в лс: {{data.item.repost_count}}</span>
  <span v-else style="color:red">Репост в лс: {{data.item.repost_count}}</span>
</div>
<div v-if="data.item.params.selectedAct == 'link'" >
  <span v-if="!data.item.params.acts.link.isBlock" style="color:#273C51">Ссылка в лс: {{data.item.link_count}}</span>
  <span v-else style="color:red">Ссылка в лс: {{data.item.link_count}}</span>
</div>
<div v-if="data.item.params.selectedAct == 'smsWithoutLink'" >
  <span v-if="!data.item.params.acts.smsWithoutLink.isBlock" style="color:#273C51">Смс без ссылки: {{data.item.sms_count}}</span>
  <span v-else style="color:red">Смс без ссылки: {{data.item.sms_count}}</span>
</div>
</div>

<div style="margin-left:-10px;margin-top:-10px">


<v-tooltip  top max-width="200">
<span>Колличество репостов в личные сообщения.</span>
<v-btn slot="activator" v-if="data.item.params.selectedAct != 'repost' && !data.item.params.acts.repost.is" disabled small  flat icon>
<v-icon  small >mdi-share</v-icon>
<span  >{{data.item.repost_count}}</span>
</v-btn>
<v-btn slot="activator" v-else-if="data.item.params.selectedAct != 'repost' && data.item.params.acts.repost.isBlock && data.item.params.acts.repost.is" disabled small  flat icon>
<v-icon  small  style="color:red !important">mdi-share</v-icon>
<span style="color:red !important">{{data.item.repost_count}}</span>
</v-btn>
<v-btn   slot="activator" @click="chAct(data.item,'repost')" v-else-if="data.item.params.selectedAct != 'repost' && !data.item.params.acts.repost.isBlock"   small  flat icon>
<v-icon  small  style="color:#273C51 !important">mdi-share</v-icon>
<span style="color:#273C51 !important">{{data.item.repost_count}}</span>
</v-btn>
</v-tooltip>

<v-tooltip top max-width="200">
<span>Колличество отправленных ссылок в личные сообщения.</span>
<v-btn slot="activator" v-if="data.item.params.selectedAct != 'link' && !data.item.params.acts.link.is" disabled small  flat icon>
<v-icon  small >mdi-link</v-icon>
<span  >{{data.item.link_count}}</span>
</v-btn>
<v-btn slot="activator" v-else-if="data.item.params.selectedAct != 'link' && data.item.params.acts.link.isBlock && data.item.params.acts.link.is" disabled small  flat icon>
<v-icon  small  style="color:red !important">mdi-link</v-icon>
<span style="color:red !important">{{data.item.link_count}}</span>
</v-btn>
<v-btn @click="chAct(data.item,'link')" slot="activator" v-else-if="data.item.params.selectedAct != 'link' && !data.item.params.acts.link.isBlock"   small  flat icon>
<v-icon  small  style="color:#273C51 !important">mdi-link</v-icon>
<span style="color:#273C51 !important">{{data.item.link_count}}</span>
</v-btn>
</v-tooltip>

<v-tooltip top max-width="200">
<span>Колличество отправленных сообщений без ссылок, но с репостом на стене аккаунта.</span>
<v-btn slot="activator" v-if="data.item.params.selectedAct != 'smsWithoutLink' && !data.item.params.acts.smsWithoutLink.is" disabled small  flat icon>
<v-icon  small >mdi-email</v-icon>
<span  >{{data.item.sms_count}}</span>
</v-btn>
<v-btn slot="activator" v-else-if="data.item.params.selectedAct != 'smsWithoutLink' && data.item.params.acts.smsWithoutLink.isBlock && data.item.params.acts.smsWithoutLink.is" disabled small  flat icon>
<v-icon  small  style="color:red !important">mdi-email</v-icon>
<span style="color:red !important">{{data.item.sms_count}}</span>
</v-btn>
<v-btn @click="chAct(data.item,'smsWithoutLink')" slot="activator" v-else-if="data.item.params.selectedAct != 'smsWithoutLink' && !data.item.params.acts.smsWithoutLink.isBlock"   small  flat icon>
<v-icon  small  style="color:#273C51 !important">mdi-email</v-icon>
<span style="color:#273C51 !important">{{data.item.sms_count}}</span>
</v-btn>
</v-tooltip>


<v-tooltip top max-width="200" v-if="data.item.acc_block_repost_count * 1 + data.item.acc_block_link_count * 1  > 0">
<span>Суммарное колличество заблокированных аккаунтов за все действия.</span>
<v-btn slot="activator" small flat icon>
<v-icon small   color="red"> mdi-account-multiple-minus </v-icon>
<span style="color:red;margin-left:3px">{{data.item.acc_block_repost_count * 1 + data.item.acc_block_link_count * 1 }}</span>
</v-btn>
</v-tooltip>

</div>


</div>
</template>




<template #cell(options)="data">

<div>

<a v-if="data.item.post_id.slice(0,4) != 'wall'">
<span style="color:#273C51;font-size:1.2em">
{{data.item.post_id.slice(0,20)}}
<v-tooltip v-if="data.item.post_id.length > 20" left max-width="250">
<span slot="activator">...</span>
<span>{{data.item.post_id}}</span>
</v-tooltip>
</span>
</a>
<a v-else target="_blank" :href="'https://vk.com/'+data.item.post_id">
<span style="cursor:pointer;color:#4A76A8;font-size:1.2em"> {{data.item.post_id}}</span>
</a>

<v-tooltip   v-if="data.item.is_important > 0"  top max-width="250">
<v-badge   slot="activator" color="#FF8F18" style="margin-left:15px;margin-bottom:10px;cursor:pointer">
<template v-slot:badge>
<v-icon @click="setImportant(data.item)" dark small>mdi-star</v-icon>
</template>
</v-badge>
<span>Кликните что бы удалить пост из избранных</span>
</v-tooltip>

<v-tooltip   v-else  top max-width="250">
<v-badge   slot="activator" color="gray" style="margin-left:15px;margin-bottom:10px;cursor:pointer">
<template v-slot:badge>
<v-icon  @click="setImportant(data.item)"  small>mdi-star</v-icon>
</template>
</v-badge>
<span>Кликните что бы добавить пост в избранное</span>
</v-tooltip>

<div style="margin-left:-5px">
<v-tooltip top max-width="250"> <span>Редактировать параметры поста</span> <v-btn class="ma-0 pa-0" slot="activator" @click="edit(data.item,'edit')"  small icon><v-icon small color="black">mdi-pencil</v-icon></v-btn> </v-tooltip>
<v-tooltip top max-width="250">
<span><span style="color:#FF8F18">Двойной клик</span> что бы <span style="color:#FF8F18">добавить</span> новый пост с такими параметрами.</span>
<v-btn class="ma-0 pa-0" slot="activator" @dblclick = "edit(data.item,'copy')"  small icon><v-icon small color="green">mdi-content-copy</v-icon>
</v-btn>
</v-tooltip>
<v-tooltip v-if="data.item.params.autoGenerate.is" top max-width="250">
<span><span style="color:#FF8F18">Двойной клик</span> что бы на основе этого поста <span style="color:#FF8F18">создать и добавить</span> новый пост автоматически.</span>
<v-btn class="ma-0 pa-0" slot="activator" @dblclick = "autoCreatePost(data.item)"  small icon><v-icon small color="green">mdi-file-plus</v-icon>
</v-btn>
</v-tooltip>
<v-tooltip top max-width="250"> <span>Удалить пост</span> <v-btn slot="activator" @click="deleteConfirm(data.item)"  small icon><v-icon small color="pink">mdi-close</v-icon></v-btn></v-tooltip>
</div>
</div>
</template>

</b-table>



<!-- Диалоговые окна -->
<v-dialog  v-model="tasks.modals.resources" max-width="900" min-width="900" max-height="500"  persistent  scrollable      >
<resources :tasks="tasks"> </resources>
</v-dialog>

<v-dialog v-if="tasks.modals.msg"  v-model="tasks.modals.msg"  width="1200"    scrollable  >
<msg  :tasks="tasks"> </msg>
</v-dialog>

<v-dialog width = "900" scrollable  persistent v-model="modals.creator">
<creatorWrapper v-if="modals.creator"  :creator="creator" :modals="modals" :tasks="tasks" ></creatorWrapper>
</v-dialog>

<!-- Диалоговые окна закрытие-->

<v-snackbar  v-model="sb.snackbar" :color="sb.color"  top    :timeout="sb.timeout">
{{sb.text}}
<v-btn dark flat @click="sb.snackbar = false">ОК</v-btn>
</v-snackbar>

</div>
</template>

<script>
import axios from 'axios'

import resources from '../../tasks/pages/taskParams/resources.vue'
import msg from '../../tasks/pages/taskParams/msg.vue'
import creatorWrapper from '../../tasks/pages/creator/creatorWrapper.vue'
import showPost from './showPost.vue'
export default {
components:{resources,msg,creatorWrapper,showPost},
props:['posts'],
data () {
return {
sb:{
snackbar: false,
color: 'success',
text: '',
timeout: 2000
},
statusList:[
  {text:"Запасной",value:"1"},
  {text:"Выбранный",value:"2"},
  {text:"Блокирован",value:"3"},
  {text:"Удален в VK",value:"4"},
],
postTasks:{},
  modals:{
    creator:false,
  },
  tasks:{
    itemka: [],
    loading:true,
    modals: {
      msg: false,
      resourcesTest:false,
      logs:false,
      resources:false,
    },
    timeoutUpdate: '',
    deleteTask: {
      modal : false,
      taskId: {},
    },
    tasksList: [],

    task:{
     startUpdateRes: '',
     modal : false,

     info: {},
     timeoutUpdate: '',
     selectedTaskId: '',
     accounts:[],
     accountsSelected: [],
     resources: {
       foundData:{
        selector: false,
        foundIds: [],
        displayIds: [],
        selectedIds: [],
        offset: 0,
        selectAll: false
      },
      foundData1:{
       selector: false,
       foundIds: [],
       displayIds: [],
       selectedIds: [],
       offset: 0,
       selectAll: false
     },
      foundDataDone:{
       selector: false,
       foundIds: [],
       displayIds: [],
       selectedIds: [],
       offset: 0,
       selectAll: false
     },
     foundDataMinus_traff:{
      selector: false,
      foundIds: [],
      displayIds: [],
      selectedIds: [],
      offset: 0,
      selectAll: false
    },
     foundDataBots:{
      selector: false,
      foundIds: [],
      displayIds: [],
      selectedIds: [],
      offset: 0,
      selectAll: false
    },
    },
     actions:{
       friendRequest:{
         conditions:{
           modal:false
         }
       },
       messageSend:{
         conditions:{
           modal:false
         }
       },
       likeAvatar:{
         conditions:{
           modal:false
         }
       },
       unFriend:{
         conditions:{
           modal:false
         }
       },
     },
     logs:[],
     params:{
       traffControl:{
         blockedToBots:true,
         removeClosedMsg:false,
         removeClosedFriendsReq:false,
         minWomen:false,
         minMen:false,
         onlyOnline:false,
         maxOffline:10,
       },
       resourcesTimeout:{
         min: 2,
         max: 90,
         range: [1, 1]
       },
       actionsTimeout:{
         min: 5,
         max: 90,
         range: [1, 1]
       },
     },
     name: ""
   }

  },
  creator:{
  creationPath: "/tasks/taks_creator.php",   // "tasks/edit_task.php"
  taskId: "",
  isEditor:false,
  panel:[false,false,false,false,false],

    filters:{
      all:[],
      selected:[],
    },

    procesess: {
      procResults: {
        items: [],
        selected: [],
        active: false,
      },
      procResultsLabel: "Привязать результаты процессов",
      procUpdates: {
        items: [],
        selected: [],
        active: true,
      },
      procUpdatesLabel: "Привязать результаты обновлений процессов",
      contentType: 'pages',
    },
    ui:{
      createLoading: false
    },
    active: null,
    sb:{
    snackbar: false,
    color: 'success',
    text: ''
  },
  newTask:{
    modals: {
      message: false,
    },
    name: '',
    accounts: [],
    accGroupId: '1',
    accGroupsList: [],
    accountsAll:[],

   preActions:{
     activated:false,

     privat:{
       is:false,
       options:{
         openProfile:{
           selected: 0,
           options:[{text:"не заданно",value:0},{text:"Закрытый профиль",value:1},{text:"Открытый профиль",value:2}],
         },
         msgRecive:{
           selected: 0,
           options:[{text:"не заданно",value:0},{text:"Все пользователи",value:1,vk_value:'all'},{text:"Только друзья аккаунта",value:2,vk_value:'friends'},{text:"Друзья друзей",value:3,vk_value:'friends_of_friends'},{text:"Никто",value:4,vk_value:'nobody'}],
         },
         whoCanPost:{
           selected: 0,
           options:[{text:"не заданно",value:0},{text:"Все пользователи",value:1,vk_value:'all'},{text:"Только друзья аккаунта",value:2,vk_value:'friends'},{text:"Только пользователь",value:3,vk_value:'only_me'}],
         },
         whoCanComment:{
           selected: 0,
           options:[{text:"не заданно",value:0},{text:"Все пользователи",value:1,vk_value:'all'},{text:"Только друзья аккаунта",value:2,vk_value:'friends'},{text:"Только пользователь",value:3,vk_value:'only_me'}],
         },
         whoCanSeeOthersComments:{
           selected: 0,
           options:[{text:"не заданно",value:0},{text:"Все пользователи",value:1,vk_value:'all'},{text:"Только друзья аккаунта",value:2,vk_value:'friends'},{text:"Только пользователь",value:3,vk_value:'only_me'}],
         },
         whoCanSeeOthersPosts:{
           selected: 0,
           options:[{text:"не заданно",value:0},{text:"Все пользователи",value:1,vk_value:'all'},{text:"Только друзья аккаунта",value:2,vk_value:'friends'},{text:"Только пользователь",value:3,vk_value:'only_me'}],
         },
       }
     },
     repost:{
       is:false,
       text:"",
       attachment:"",
       pin:0,
       close_comments:0,
       add_like:0,
       make_comment:{is:0,text:''},

     },
     post:{
       is:false,
       text:"",
       pin:0,
       close_comments:0,
       add_like:0,
       make_comment:{is:0,text:''},

     },
   },

   actions:{
   friendRequest:   {
       type: 'friendRequest',
       activated: false,
       text: "",
       afterAccept:{
         is:false,
         text: "",
       },
     },
     messageSend:   {
         type: 'messageSend',
         activated: false,
         text:"",
         attachments: "",
         text2: "",
         deletAfter: false,
         repostPost:0,
         repostRepost:0,
       },
   likeAvatar:   {
           type: 'likeAvatar',
           activated: false,
           conditions:{
             modal: false,
             activated: false,
             type: "pages",
           }
         },
   postActions: {
           type: 'postActions',
           activated: false,
           conditions:{
             modal: false,
             activated: false,
             type: "pages",
               }
               },
         unFriend:   {
                 type: 'unFriend',
                 activated: false,
                 conditions:{
                   modal: false,
                   activated: false,
                   type: "pages",
                 }
               },
   },
    resources:"",
    resourcesTimeout:{
      min: 0,
      max: 90,
      range: [1, 1]
    },
    actionsTimeout:{
      min: 0,
      max: 90,
      range: [1, 1]
    },
    accountSettings:{
      mode: 1,
      options: [{value:1, text:"Выполнять задание рандомно с одного аккаунта"},{value:2, text:"Выполнять задание с каждого  аккаунта по порядку"}],
    },
    stopLimit: null,
    stopBlock: null,
    replaceThenLimit: null,
    replaceThenBlock: null,
    sequentialBlock:{
    is:false,
    accCount:5,

    stopTask:true,
    },
    allActionsImportant: true,
    exceptDuble: true,


    traffControl:{
      blockedToBots:true,
      removeClosedMsg:false,
      removeClosedFriendsReq:false,
      minWomen:false,
      minMen:false,
      onlyOnline:false,
      maxOffline:10,
    },

  }
  },
}
},
methods:{


autoCreatePost(post){
this.sb.snackbar = true
this.sb.text = "Пробую создать новый пост, ожидайте..."
this.sb.color = "#4A76A8"
this.sb.timeout = 30000
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/posts/new_vk_post_auto.php', {
method: 'POST',
data:{
postId:post.post_id,
}
}).then(response => {
this.sb.timeout = 2000
if(response.data.error_text){
this.sb.snackbar = true
this.sb.text = response.data.error_text
this.sb.color = "red"
} else {
this.$router.go()
}
})
.catch(error=>{
this.sb.snackbar = true
this.sb.text = error
this.sb.color = "red"
})
},

chAct(item,selectedAct){
item.params.selectedAct = selectedAct
axios.post('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/posts/add_posts.php', {
params:{
  params:item,
  editStatus:"edit"
}
}).then(response => {
this.$router.go()

})

},
setImportant(item){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/posts/set_important.php', {
method: 'POST',
data:{
postId:item.post_id,
}
}).then(response => {
if(item.is_important > 0){item.is_important = 0} else item.is_important = 1
})
},
chStatus(postId,status){
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/posts/ch_status.php', {
  contentType: 'JSONP',
  method: 'get',
  params:{
    postId:postId,
    status:status
  }
  }).then(response => {
  //this.$router.go()

  })
},
chTask(postId,taskId){
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/posts/ch_task_id.php', {
  contentType: 'JSONP',
  method: 'get',
  params:{
    postId:postId,
    taskId:taskId
  }
  }).then(response => {
  this.$router.go()

  })
},

deleteConfirm(item){
this.posts.modals.deletePost = true
this.posts.selectedPost = item
},

edit(item,status){
//console.log(item)
this.posts.editStatus = status
this.posts.selectedPost = item
if(status === 'copy'){
// сбросить счетчики и поменять статус
this.posts.selectedPost.post_id = ''
this.posts.selectedPost.status = "1"
this.posts.selectedPost.acc_block_repost_count = "0"
this.posts.selectedPost.acc_block_link_count = "0"
this.posts.selectedPost.repost_count = "0"
this.posts.selectedPost.link_count = "0"
this.posts.selectedPost.sms_count = "0"
// обнуляем настройки анализа  блока поста
this.posts.selectedPost.params.check_post.last_time = ''
this.posts.selectedPost.params.check_post.pageIs = 'ok'
this.posts.selectedPost.params.check_post.linkIs = ''
this.posts.selectedPost.params.check_post.linkUrl = ''
this.posts.selectedPost.params.check_post.pageType = 'page'
this.posts.selectedPost.params.check_post.pageId = ''
// сбросить блокировки на действиях
this.posts.selectedPost.params.acts.repost.isBlock = false
this.posts.selectedPost.params.acts.link.isBlock = false
this.posts.selectedPost.params.acts.smsWithoutLink.isBlock = false
}
this.posts.modals.editor = true
//console.log(this.posts.selectedPost)
},


taskResources(item){
this.tasks.modals.resources = true
this.tasks.task.info = this.postTasks[item.task_id]
this.tasks.task.info.task_id = item.task_id
this.tasks.task.name = this.postTasks[item.task_id].name

this.tasks.task.resources.foundData.selector = false
this.tasks.task.resources.foundData.foundIds = []
this.tasks.task.resources.foundData.displayIds = []
this.tasks.task.resources.foundData.selectedIds = []
this.tasks.task.resources.foundData.offset = 0
this.tasks.task.resources.foundData.selectAll = false

this.tasks.task.resources.foundDataDone.selector = false
this.tasks.task.resources.foundDataDone.foundIds = []
this.tasks.task.resources.foundDataDone.displayIds = []
this.tasks.task.resources.foundDataDone.selectedIds = []
this.tasks.task.resources.foundDataDone.offset = 0
this.tasks.task.resources.foundDataDone.selectAll = false

},
taskMsg(item){
this.tasks.modals.msg = true
this.tasks.task.info = this.postTasks[item.task_id]
this.tasks.task.name = this.postTasks[item.task_id].name
},
changeParams(item){

this.creator.taskId  = item.task_id
this.creator.isEditor = true
this.creator.panel = [false,false,false,false]
this.creator.creationPath = "/tasks/edit_task.php"
const actions = JSON.parse(this.postTasks[item.task_id].actions)
const params = JSON.parse(this.postTasks[item.task_id].params)
this.creator.newTask.name = this.postTasks[item.task_id].name
this.creator.newTask.accGroupId = this.postTasks[item.task_id].act_acc_gr
this.taskAccounts(item.task_id)
this.creator.newTask.preActions = JSON.parse(this.postTasks[item.task_id].preActions)
this.creator.newTask.accounts = JSON.parse(this.postTasks[item.task_id].act_accounts)
this.creator.newTask.actions = actions
this.creator.newTask.resources = this.postTasks[item.task_id].resurces
this.creator.newTask.traffControl = params.traffControl

this.creator.newTask.resourcesTimeout = params.resourcesTimeout
this.creator.newTask.actionsTimeout = params.actionsTimeout
this.creator.newTask.stopBlock = params.stopBlock
this.creator.newTask.stopLimit = params.stopLimit
this.creator.newTask.replaceThenBlock = params.replaceThenBlock
this.creator.newTask.replaceThenLimit = params.replaceThenLimit
this.creator.newTask.sequentialBlock  = params.sequentialBlock
this.creator.newTask.exceptDuble = params.exceptDuble
this.creator.newTask.allActionsImportant = params.allActionsImportant
this.creator.newTask.accountSettings.mode = params.accountsMode
this.creator.procesess.procUpdates.selected = JSON.parse(this.postTasks[item.task_id].dynamic_resources).procesess
this.creator.filters.selected = params.filters

this.modals.creator = true
},

taskAccounts(item){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/accounts/accounts_get.php', {
method: 'GET',
params: {grId:this.postTasks[item].act_acc_gr},
})
.then( response => {
this.creator.newTask.accountsAll = response.data
})
},

activate(item, status){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/activator.php', {
method: 'POST',
data: {
id: item.task_id,
status:status
}
})
.then( response => {
this.postTasks[item.task_id].status  = JSON.parse(response.data.status)
if(response.data.status){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/page_actions.php', {
method: 'POST', data:{id:response.data.task_id }
})
.then( response=>{
this.tasksData()
})
}
})
},

getTasksForPosts(){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/tasks_for_posts.php', {
contentType: 'JSONP',method: 'get'})
.then(response => {
this.postTasks = response.data
})
},

tasksData(){
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/task_for_export.php', {
       method: 'POST',
       data: {
         contentType: 'pages'
       }
     })
     .then( response => {
       this.tasks.loading = false
          response.data.forEach(
         (item,i,arr)=>{
           item.status = JSON.parse(item.status)
         }
       )
       response.data.forEach(item=>{
       item.actions = JSON.parse(item.actions)
       if(item.actions.postActions.activated === true){this.tasks.tasksList.push(item)}
       })
       //this.tasks.tasksList = response.data
     })

},

},
created(){

},

mounted(){
this.getTasksForPosts()
this.tasksData()
},
beforeDestroy() {
clearTimeout(this.tasks.timeoutUpdate);
},

filters:{
dateFormat(item){
var months = ['Янв.','Фев.','Мар.','Апр.','Мая','Июнь.','Июль.','Авг.','Сен.','Окт.','Ноя.','Дек.'];
let d =  new Date(item * 1000)
return  d.getDate()+" "+months[d.getMonth()]+"  "+ d.getHours() +":"+ d.getMinutes()
}
},

}
</script>

<style   >

</style>
